import Feed from './Feed';

export { Feed };
